import billRequestMessages from './localization/index.ts'
import router from './router.ts'

export default {
  router,
  localization: billRequestMessages,
}
